export default __webpack_public_path__ + "static/media/closed.61ad4dbf.svg";